import React, { useState, useEffect } from 'react';
import { useLocation, Navigate, Link, useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie';
import '../index.css';
import logo from '../assets/spinner.gif'
import { performInventoryInput, UseLocalStorage, GetAttributesByAssignment } from "../functions";

function InventoryMaint() {
    const [localStorageAttributes, setLocalStorageAttributes] = UseLocalStorage('attributes', []);

    const navigate = useNavigate();
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [modalText, setModalText] = React.useState("Error saving");
    const [modalType, setModalType] = React.useState("error"); // "success" or "error"
    const [loading, setLoading] = useState(false);

    function openModal(success) {
        setModalType(success ? "success" : "error");
        setIsOpen(true);

        setTimeout(() => {
            closeModal();
            if (success) {
                navigate('/Inventory');
            }
        }, 2200);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const location = useLocation();

    const inventoryItem = location.state

    const [item, setItem] = useState(inventoryItem ? inventoryItem.item : "");
    const [description, setDescription] = useState(inventoryItem ? inventoryItem.description : "");
    const [qty, setQty] = useState(inventoryItem ? inventoryItem.qty : "");
    const [price, setPrice] = useState(inventoryItem ? inventoryItem.price : "");
    const [location_field, setLocationField] = useState(inventoryItem ? inventoryItem.location : "");

    const inventoryAttributes = GetAttributesByAssignment('inventory', localStorageAttributes);
    const inventoryTags = inventoryAttributes?.tags?.sort((a, b) => a.displayorder.localeCompare(b.displayorder)) || [];

    let pageTitle = inventoryItem ? "Update " + (inventoryAttributes?.displayname || "Inventory Item") : "Create " + (inventoryAttributes?.displayname || "Inventory Item");
    let submitText = inventoryItem ? "Update" : "Create";

    useEffect(() => {
        // Any initialization logic can go here
    }, [])

    const cookies = new Cookies();
    let login = cookies.get('login');
    if (!login) {
        return (<Navigate to={{ pathname: '../Login' }} />);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        let data = {};
        data.item = item;
        data.description = description;
        data.qty = qty;
        data.price = price;
        data.location = location_field;

        setLoading(true);

        try {
            const result = await performInventoryInput(data);
            if (result) {
                let localStorageInventory = JSON.parse(localStorage.getItem('inventory')) || [];

                if (inventoryItem) {
                    // Update existing inventory item
                    const itemIndex = localStorageInventory.findIndex(item => item.item === inventoryItem.item);
                    if (itemIndex !== -1) {
                        localStorageInventory[itemIndex] = data;
                    } else {
                        // If not found, add as new
                        localStorageInventory.push(data);
                    }
                } else {
                    // Add new inventory item
                    localStorageInventory.push(data);
                }

                localStorage.setItem('inventory', JSON.stringify(localStorageInventory));
                setModalText('Inventory item ' + data.item + ' saved successfully!');
                setLoading(false);
                openModal(true);
            } else {
                setModalText('Error saving inventory item. Please try again.');
                setLoading(false);
                openModal(false);
            }
        } catch (error) {
            console.error('Error saving inventory item:', error);
            setModalText('Error saving inventory item. Please try again.');
            setLoading(false);
            openModal(false);
        }
    };

    const tagItem = inventoryTags.find(item => item.tag === 'item') || { displayname: 'Item', enabled: 'true' };
    const tagDescription = inventoryTags.find(item => item.tag === 'description') || { displayname: 'Description', enabled: 'true' };
    const tagQty = inventoryTags.find(item => item.tag === 'qty') || { displayname: 'Quantity', enabled: 'true' };
    const tagPrice = inventoryTags.find(item => item.tag === 'price') || { displayname: 'Price', enabled: 'true' };
    const tagLocation = inventoryTags.find(item => item.tag === 'location') || { displayname: 'Location', enabled: 'true' };

    return (
        <>
            <div className="InventoryMaint">
                <h1>{pageTitle}</h1>

                {/* Success/Error Modal */}
                {modalIsOpen && (
                    <div className="custom-modal-overlay" onClick={closeModal}>
                        <div
                            className={`custom-modal ${modalType === "success" ? "success" : "error"}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="modal-icon">
                                {modalType === "success" ? (
                                    <div className="checkmark-circle">
                                        <div className="checkmark"></div>
                                    </div>
                                ) : (
                                    <div className="error-circle">
                                        <div className="error-x"></div>
                                    </div>
                                )}
                            </div>
                            <h2 className="modal-title">
                                {modalType === "success" ? "Success!" : "Error!"}
                            </h2>
                            <p className="modal-message">{modalText}</p>
                            <div className="modal-progress-bar">
                                <div className="modal-progress-fill"></div>
                            </div>
                            {modalType === "success" && (
                                <p className="modal-redirect-text">Redirecting to inventory...</p>
                            )}
                        </div>
                    </div>
                )}

                <div className="customer-form-container">
                    <form className="customer-form" onSubmit={handleSubmit}>
                        <div className="form-section">
                            <h3>Inventory Information</h3>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="item">{tagItem.displayname}</label>
                                    <input
                                        type="text"
                                        id="item"
                                        value={item}
                                        onChange={(e) => setItem(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>

                            {tagDescription.enabled === 'true' && (
                                <div className="form-row">
                                    <div className="form-group full-width">
                                        <label htmlFor="description">{tagDescription.displayname}</label>
                                        <textarea
                                            id="description"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            rows={3}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="form-row">
                                {tagQty.enabled === 'true' && (
                                    <div className="form-group">
                                        <label htmlFor="qty">{tagQty.displayname}</label>
                                        <input
                                            type="number"
                                            id="qty"
                                            value={qty}
                                            onChange={(e) => setQty(e.target.value)}
                                            min="0"
                                        />
                                    </div>
                                )}

                                {tagPrice.enabled === 'true' && (
                                    <div className="form-group">
                                        <label htmlFor="price">{tagPrice.displayname}</label>
                                        <input
                                            type="number"
                                            id="price"
                                            value={price}
                                            onChange={(e) => setPrice(e.target.value)}
                                            min="0"
                                            step="0.01"
                                        />
                                    </div>
                                )}
                            </div>

                            {tagLocation.enabled === 'true' && (
                                <div className="form-row">
                                    <div className="form-group">
                                        <label htmlFor="location">{tagLocation.displayname}</label>
                                        <input
                                            type="text"
                                            id="location"
                                            value={location_field}
                                            onChange={(e) => setLocationField(e.target.value)}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="form-submit">
                                <button type="submit" disabled={loading}>
                                    {loading ? 'Saving...' : submitText}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );

}

export default InventoryMaint;